export const BOOKMARK_COURSE_REQUEST = "BOOKMARK_COURSE_REQUEST";
export const BOOKMARK_COURSE_SUCCESS = "BOOKMARK_COURSE_SUCCESS";
export const BOOKMARK_COURSE_FAIL = "BOOKMARK_COURSE_FAIL";